import { Fragment, useEffect, useState, useMemo, useCallback } from 'react';
import { Container } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumbs } from '../../../../AbstractElements';
import { getAllPaymentHistoryAPI } from '../../../../Library/apis';
import Transactions from './Transactions';

const BankTransfer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const LIMIT = 20;

  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  
  const [currentPage, setCurrentPage] = useState(Number(queryParams.get('page')) || 1);
  const [lastKnownPage, setLastKnownPage] = useState(Number(queryParams.get('page')) || 1);
  
  const [activeFilters, setActiveFilters] = useState({
    firstName: queryParams.get('firstName') || '',
    lastName: queryParams.get('lastName') || '',
    userId: queryParams.get('userId') || '',
    bankName: queryParams.get('bankName') || '',
    bankAccountNumber: queryParams.get('bankAccountNumber') || '',
    dateFrom: queryParams.get('dateFrom') || '',
    dateTo: queryParams.get('dateTo') || '',
  });

  const fetchData = useCallback((newFilters, newPage) => {
    // Sync URL
    const params = new URLSearchParams();
    if (newPage > 1) params.set('page', newPage);
    Object.keys(newFilters).forEach(key => {
      if (newFilters[key]) params.set(key, newFilters[key]);
    });
    navigate({ search: params.toString() }, { replace: true });

    setIsLoading(true);
    getAllPaymentHistoryAPI(
      { ...newFilters, type: 'Withraw' }, 
      newPage,
      LIMIT
    )
      .then(res => {
        setData(res.body || []);
        setTotalRows(res.pagination?.total || 0);
        setCurrentPage(newPage);
        setActiveFilters(newFilters);

        // Pagination Memory: If no search is active, remember this page
        const isSearching = Object.values(newFilters).some(v => !!v);
        if (!isSearching) {
          setLastKnownPage(newPage);
        }
      })
      .catch(() => {
         setData([]);
         setTotalRows(0)
      }).finally(() => setIsLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchData(activeFilters, currentPage);
  }, []);

  const handleSearch = (filters) => fetchData(filters, 1);
  const handlePageChange = (page) => fetchData(activeFilters, page);
  const handleReset = () => fetchData({}, lastKnownPage);
  const handleRefresh = () => fetchData(activeFilters, currentPage);  
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Reports/Records' />
      <Container fluid={true}>
        <Transactions
          data={data}
          isLoading={isLoading}
          totalRows={totalRows}
          currentPage={currentPage}
          onSearch={handleSearch}
          onPageChange={handlePageChange}
          onReset={handleReset}
          onRefresh={handleRefresh}
          activeFilters={activeFilters}
          limit={LIMIT}
        />
      </Container>
    </Fragment>
  );
};

export default BankTransfer;